export function scanApp() {
    const root = document.getElementById('scan-app');
    if (!root) return; // veiligheid: alleen draaien waar de scan aanwezig is

    // Haal brondata (vragen/antwoorden) uit de inline JSON
    const dataEl = document.getElementById('scan-data');
    if (!dataEl) return;

    const questions = JSON.parse(dataEl.textContent || '[]');
    const totalQuestions = questions.length;
    if (!totalQuestions) return;

    // Houdt bij op welke vraag we zitten (0-based index)
    let currentIndex = 0;

    // Cache template referenties voor klonen
    const templates = {
        question: document.getElementById('question-template'),
        result: document.getElementById('result-template')
    };

    if (!templates.question || !templates.result) return;

    // Element van de voortgangsbalk (de vulling die in breedte groeit)
    const progressFill = document.querySelector('.scan__progress-fill');

    /**
     * Update voortgangsbalk voor een vraagstap (bijv. 1/3 → ~33%)
     */
    const updateProgressForQuestion = (index) => {
        if (!progressFill) return;
        const percent = Math.max(0, Math.min(100, Math.round(((index + 1) / totalQuestions) * 100)));
        progressFill.style.width = percent + '%';
        progressFill.setAttribute('aria-valuenow', String(percent));
    };

    /**
     * Zet voortgang op 100% (bij het tonen van het resultaat)
     */
    const updateProgressComplete = () => {
        if (!progressFill) return;
        progressFill.style.width = '100%';
        progressFill.setAttribute('aria-valuenow', '100');
    };

    /**
     * Logica voor de 'Previous'-knop:
     * - Als we NIET op de eerste vraag zitten → ga één stap terug.
     * - Als we WEL op de eerste vraag zitten → history.back() → breadcrumb → fallback '/'
     */
    const handlePrev = (breadcrumbHref) => {
        if (currentIndex > 0) {
            currentIndex--;
            renderQuestion(currentIndex);
            return;
        }
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        if (breadcrumbHref) {
            window.location.href = breadcrumbHref;
            return;
        }
        window.location.href = '/';
    };

    /**
     * Render één vraag met antwoordknoppen
     */
    const renderQuestion = (index) => {
        const container = document.getElementById('scan-output');
        if (!container) return;

        container.innerHTML = ''; // reset de output

        const question = questions[index];
        const clone = templates.question.content.cloneNode(true);

        // Vraagnummer + titel invullen
        const numberEl = clone.querySelector('.scan__question-number');
        const titleEl = clone.querySelector('.scan__question-title');
        if (numberEl) numberEl.textContent = `Vraag ${index + 1}/${totalQuestions}`;
        if (titleEl) titleEl.textContent = `${index + 1}. ${question.question_title}`;

        // 'Previous'-knop laten werken (altijd zichtbaar)
        const prevBtn = clone.querySelector('.scan__nav-btn--prev');
        const breadcrumbLink = clone.querySelector('.scan__breadcrumb a');
        const breadcrumbHref = breadcrumbLink ? breadcrumbLink.getAttribute('href') : null;
        if (prevBtn) {
            prevBtn.addEventListener('click', () => handlePrev(breadcrumbHref));
        }

        // Antwoorden renderen als knoppen
        const answersWrapper = clone.querySelector('.scan__answers');
        if (answersWrapper) {
            question.answers.forEach((answer, i) => {
                const button = document.createElement('button');
                button.classList.add('btn', 'scan__answer-btn');
                button.classList.add(i === 0 ? 'btn--primary' : 'btn--secondary');
                button.textContent = answer.label;

                // Klik op antwoord:
                // - 'question' → naar volgende vraag
                // - 'result'   → toon het resultaat
                button.addEventListener('click', () => {
                    if (answer.action_type === 'question') {
                        renderQuestion(++currentIndex);
                    } else if (answer.action_type === 'result') {
                        renderResult(answer.result);
                    }
                });

                answersWrapper.appendChild(button);
            });
        }

        // Voeg vraag in de DOM
        container.appendChild(clone);

        // Update voortgangsbalk voor deze vraag
        updateProgressForQuestion(index);
    };

    /**
     * Render het resultaat-scherm
     */
    const renderResult = (result) => {
        const container = document.getElementById('scan-output');
        if (!container) return;

        container.innerHTML = ''; // reset de output

        const clone = templates.result.content.cloneNode(true);

        // 'Previous'-knop ook in resultaat-header koppelen
        const prevBtn = clone.querySelector('.scan__nav-btn--prev');
        const breadcrumbLink = clone.querySelector('.scan__breadcrumb a');
        const breadcrumbHref = breadcrumbLink ? breadcrumbLink.getAttribute('href') : null;
        if (prevBtn) {
            prevBtn.addEventListener('click', () => handlePrev(breadcrumbHref));
        }

        // Resultaatafbeelding (optioneel)
        if (result && result.image) {
            const img = clone.querySelector('img');
            if (img) {
                img.src = result.image.url;
                img.alt = result.image.alt || '';
            }
        } else {
            const imgWrap = clone.querySelector('.scan__result-image');
            if (imgWrap) imgWrap.remove();
        }

        // Titel en tekst (tekst mag HTML bevatten → innerHTML)
        if (result && result.title) {
            const titleEl = clone.querySelector('.scan__result-title');
            if (titleEl) titleEl.textContent = result.title;
        }
        if (result && result.text) {
            const textEl = clone.querySelector('.scan__result-text');
            if (textEl) textEl.innerHTML = result.text;
        }

        // Primaire CTA (optioneel)
        const ctaEl = clone.querySelector('.scan__result-cta');
        if (result && result.primary_button_label && result.primary_button_link) {
            if (ctaEl) {
                ctaEl.href = result.primary_button_link;
                ctaEl.textContent = result.primary_button_label;
            }
        } else if (ctaEl) {
            ctaEl.remove();
        }

        // Plaats resultaat in DOM
        container.appendChild(clone);

        // Voltooi voortgang
        updateProgressComplete();
    };

    // Start de flow met de eerste vraag
    renderQuestion(currentIndex);
}